import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader


Vue.use(Vuetify);

export default new Vuetify({
    rtl: false,
    theme: {
        themes: {
            light: {
                primary: "#ffc107",
                secondary: "#FBFAF4",
                accent: "#D63900",
                error: "#f44336",
                warning: "#ffeb3b",
                info: "#03a9f4",
                success: "#4caf50"
            }
        }
    },
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    }
});
